export const HOME_ROUTE = "/";
export const BIOGRAPHY_ROUTE = "/biografie";
export const CONTACT_ROUTE = "/kontakt";
export const TWO_THOUSAND_TEN_TO_TWO_THOUSAND_TWENTY_FIVE_ROUTE = "/2010-2025";
export const NINETEEN_NINETY_TO_TWO_THOUSAND_NINE_ROUTE = "/1990-2009";
export const NINETEEN_EIGHTY_TO_NINETEEN_NINETY_ROUTE = "/1980-1989";
export const GRAPHIC_ROUTE = "/grafik";
export const DRAWING_ROUTE = "/zeichnung";
export const ACRYL_ROUTE = "/acryl";
export const TRAVEL_ROUTE = "/reisen";
export const PORTRAIT_ROUTE = "/portraet";

export const HANS_ZITKO_ROUTE = "/hans-zitko";
export const TIM_SOMMER_ROUTE = "/tim-sommer";
export const CONSTANZE_TREUNER_ROUTE = "/constanze-treuner";
export const SIMONE_TIPPACH_SCHNEIDER_ROUTE = "/simone-tippach-schneider";
